export const NO_CANDIDATES_MESSAGE = "No matching Google Places found.";
export const SEARCH_ERROR_MESSAGE =
  "Unable to search Google Places. Please try again later.";
